import './AboutGame.scss';
import chatGpt from '../../../images/home/ChatGPT.png';
import featuresContent from '../../../data/GameFeatures.json';
import { useInView } from 'react-intersection-observer'

import first from '../../../images/home/game_features/first.jpg'
import second from '../../../images/home/game_features/second.jpg'
import third from '../../../images/home/game_features/third.jpg'

const getImage = (feture: string) => {
  switch(feture) {
    case 'first':
      return first;

    case 'second':
      return second;

    case 'third':
      return third;

      default:
        throw new Error('something went wrong!')
  }
}

const AboutGame = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    fallbackInView: true,
  });

  return (
    <section className="about_game" ref={ref}>
      <section className="container about_game__container">
        <div className="main_info">
          <div className="main_info__top">
            <h1>
              <span className="bold">Infinite</span> UNIVERSE SOLARIS
            </h1>
            <p className="bold main_info__partners_title">
              OUR PARTNERS WHO HELP US MAKE BREAKTHROUGHS IN THE FUTURE OF VIDEO GAMES AND META UNIVERSES 
            </p>
            <ul className="main_info__partners">
              <li className="main_info__partners_item">
                <img src={chatGpt} alt="chat gpt" className="chat-gpt"/>
                <h2 className="bold">ChatGPT</h2>
              </li>
              <li className="main_info__partners_item">
                <h2 className="bold">BLOOM</h2>
              </li>
              <li className="main_info__partners_item">
                <h2 className="bold">DALL-E 2</h2>
              </li>
            </ul>
          </div>
          <div className="main_info__bottom">
            <p className="main_info__text">
              In our meta-universe, artificial intelligence plays a key role in creating and maintaining all of its content. It is responsible for generating planets, asteroids, and other space objects, as well as creating and controlling characters (NPCs).
            </p>
            <p className="main_info__text">
              The Solaris meta-universe is a new "word" not only within blockchain projects, but also in the gaming industry as a whole. 
            </p>
          </div>
            <p className="main_info__post_script">
              All content generated by artificial intelligence is manually moderated by the game's authors*
            </p>
        </div>

        <div className="info_game">
          <h2 className="bold">
            DISCOVER, COLLECT, BUILD
          </h2>
          <p>
            Explore planets and discover the fauna, flora, and resources needed to craft everything from medicine and food to equipment and weapons. Build outposts and hire a crew to passively extract materials and establish cargo links to transfer resources between them. Invest these raw materials into research projects to unlock unique crafting recipes
          </p>
        </div>

        <ul className="game_features">
          {inView && featuresContent.map((currentFeature, i) => {
            const {photo, text} = currentFeature;

            return (
              <li key={i} className="game_features__item">
                <img
                  src={getImage(photo)}
                  alt={`${i} feature`}
                  className="game_features__image"
                />
                <p>
                  {text}
                </p>
              </li>
            );
          })}
        </ul>

      </section>
    </section>
  );
};

export default AboutGame;